export default (() => {
    let internalId = 0;
    let togglesMap = {};
    const targetsMap = {};

    function $(selector, context) {
        return Array.prototype.slice.call(
            (context || document).querySelectorAll(selector)
        );
    }

    function getClosestToggle(element) {
        if (element.closest) {
            return element.closest('[data-a11y-toggle]');
        }

        while (element) {
            if (
                element.nodeType === 1 &&
                element.hasAttribute('data-a11y-toggle')
            ) {
                return element;
            }

            element = element.parentNode;
        }

        return null;
    }

    function handleToggle(toggle) {
        const target =
            toggle && targetsMap[toggle.getAttribute('aria-controls')];

        if (!target) {
            return false;
        }

        const otherToggles = togglesMap[`#${target.id}`];
        const isExpanded = target.getAttribute('aria-hidden') === 'false';

        target.setAttribute('aria-hidden', isExpanded);
        otherToggles.forEach(otherToggle => {
            otherToggle.setAttribute('aria-expanded', !isExpanded);
        });

        document.body.classList.toggle('modal-open', !isExpanded);

        return true;
    }

    const initA11yToggle = context => {
        togglesMap = $('[data-a11y-toggle]', context).reduce((acc, toggle) => {
            const selector = `#${toggle.getAttribute('data-a11y-toggle')}`;
            acc[selector] = acc[selector] || [];
            acc[selector].push(toggle);
            return acc;
        }, togglesMap);

        const targets = Object.keys(togglesMap);
        if (targets.length) {
            $(targets).forEach(target => {
                const toggles = togglesMap[`#${target.id}`];
                const isExpanded = target.hasAttribute('data-a11y-toggle-open');
                const labelledby = [];

                toggles.forEach(toggle => {
                    if (!toggle.id) {
                        toggle.setAttribute(
                            'id',
                            `a11y-toggle-${internalId++}`
                        );
                    }
                    toggle.setAttribute('aria-controls', target.id);
                    toggle.setAttribute('aria-expanded', isExpanded);
                    labelledby.push(toggle.id);
                });

                target.setAttribute('aria-hidden', !isExpanded);
                if (!target.hasAttribute('aria-labelledby')) {
                    target.setAttribute(
                        'aria-labelledby',
                        labelledby.join(' ')
                    );
                }

                targetsMap[target.id] = target;
            });
        }
    };

    document.addEventListener('DOMContentLoaded', () => {
        initA11yToggle();
    });

    document.addEventListener('click', event => {
        const toggle = getClosestToggle(event.target);
        handleToggle(toggle);
    });

    document.addEventListener('keyup', event => {
        if (event.which === 13 || event.which === 32) {
            const toggle = getClosestToggle(event.target);
            if (toggle && toggle.getAttribute('role') === 'button') {
                handleToggle(toggle);
            }
        }
    });

    if (window) {
        window.a11yToggle = initA11yToggle;
    }
})();



// WEBPACK FOOTER //
// src/js/plugins/a11y-toggle.js